import { action, computed, makeObservable, observable } from 'mobx';
import { EventEmitter } from 'events';

export class ToggleState {
  public value: boolean;
  readonly events = new EventEmitter();

  constructor(initialValue = false) {
    this.value = initialValue;

    makeObservable(this, {
      value: observable,
      isOn: computed,
      isOff: computed,
      toggle: action.bound,
      setOff: action.bound,
      setOn: action.bound,
    });
  }

  public get isOn() {
    return this.value;
  }

  public get isOff() {
    return !this.value;
  }

  public toggle(value = !this.value) {
    if (this.value !== value) {
      this.value = value;
      this.events.emit('toggle');
    }
  }

  setOff() {
    this.toggle(false);
    // return new Promise<void>((resolve) => {
    //   this.events.once('afterClose', resolve);
    // });
  }

  setOn() {
    this.toggle(true);
    this.events.emit('open');
  }
}
